import { Pipe, PipeTransform } from '@angular/core';
import { UtilsService } from 'src/app/services';

@Pipe({
  name: 'utcDateTime',
})
export class UtcDateTimePipe implements PipeTransform {
  constructor(private utilsService: UtilsService) {}

  transform(dateTime: Date | string | number[] | null | undefined): Date | null {
    return dateTime ? this.utilsService.convertDate(dateTime) : null;
  }
}
